var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9306 11H18.0806C16.3933 11 15.0205 12.3768 15.0205 14.0693V15.0196H14.0601C12.3727 15.0196 11 16.3964 11 18.0898V33.9307C11 35.6232 12.3727 37 14.0601 37H29.9105C31.6034 37 32.9803 35.6232 32.9803 33.9307V32.9804H33.9306C35.6234 32.9804 37.0008 31.6036 37.0008 29.9102V14.0692C37.0008 12.3768 35.6234 11 33.9306 11V11ZM31.1017 33.9306C31.1017 34.5874 30.5674 35.1213 29.9105 35.1213H14.0601C13.4088 35.1213 12.8786 34.5874 12.8786 33.9306V18.0897C12.8786 17.433 13.4089 16.8981 14.0601 16.8981H15.9599H29.9105C30.5673 16.8981 31.1017 17.4329 31.1017 18.0897V32.0409V33.9306ZM35.1221 29.9101C35.1221 30.5668 34.5878 31.1017 33.9305 31.1017H32.9802V18.0897C32.9802 16.3964 31.6034 15.0195 29.9104 15.0195H16.8991V14.0692C16.8991 13.4124 17.4293 12.8785 18.0805 12.8785H33.9305C34.5877 12.8785 35.1221 13.4124 35.1221 14.0692V29.9101Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b277619e.svg";
export { ForwardRef as ReactComponent };